
import { useEffect, useState } from 'react';
import { apiDomain, warName } from '../../../..';
import { getLabel } from '../../../../data/labels';
import Loader from '../../../../common/Loader';
import { useFetchCheckbetTicket } from '../../../fetchCheckbetTicket';
import { getConfiguration } from '../../../utils/configuration';
import { getQueryStringVariable } from '../../../utils/getQueryStringVariable';
import { isUKCombinationMaskEnabled } from '../../../utils/isUKCombinationMaskEnabled';
import { restoreTicketDataWithUkCombinations } from '../../../utils/restoreTicketDataWithUkCombinations';
import Legend from '../Legend';
import MultipleBetsTicket from './MultipleBetsTicket';
import SingleBetTicket from './SingleBetTicket';
import SystemBetsTicket from './SystemBetsTicket';


function CheckBetLayout3(props) {
    import ('../my-bets.min.css');
    const [data, setData] = useState(null);
    const [showLoader, setShowLoader] = useState(true);
    const conf = getConfiguration();
    const logoURL = conf.logo ? `${apiDomain}/${warName}/content/images/customer-logo/${conf.logo}` : '';
    const ticketId =  getQueryStringVariable('ticketId') || getQueryStringVariable('ticket') || props.ticketId;
    const hideLogo = getQueryStringVariable('hideLogo') === 'true';
    const layoutVersion = conf?.mbt ?? '';
    
    var isLive = false;
    if(data && data.live){
        isLive = true;
    }
    const [state] = useFetchCheckbetTicket(ticketId, true, isLive, isLive);

        useEffect(() => {
            if (layoutVersion === 'V3') {
                import('../MyBetsLayout3.css');
            }
        }, []);

    useEffect(() => {
        if (!state.isLoading && !state.isError) {
            if(state.data && isUKCombinationMaskEnabled() && state.data.type === 'systembets'){
            	restoreTicketDataWithUkCombinations(state.data, true);
            }
            setData(state.data);
            setShowLoader(false);
            if(props.onDataFetchComplete) {
                props.onDataFetchComplete(state.data);
            }
        }
    }, [state.data, state.isError, state.isLoading]);
     
    return (!props.hideCheckbetLayout &&
        <div id="xs-my-bets-layout-2" className='xs-my-bets-layout-3-version'>
            {showLoader ?
                <Loader error={state.isError} positionRelative={props.isModal} />
                :
                <div id="cg-mybet-body" className="cg-mybet-section">
                    {!props.infoTicket && !hideLogo &&                	
                        <div id="checkbet-logo-container">
                            <img src={logoURL} alt="" />
                        </div>
                    }
                    {data == null ?
                        <div id="my-bets-container">
                            <span>{getLabel('checkbet.wrong_ticket_id', 'Ticket non esistente')}</span>
                        </div>
                        :
                        <>
                            <div id="my-bets-container" className="mb_2">
                                {data.type === 'singlebets' &&
                                    <SingleBetTicket key={data.id} ticket={data} infoTicket={props.infoTicket} obfuscateTicketId={props.obfuscateTicketId} isSnapshot={props.isSnapshot} />
                                }
                                {data.type === 'multibets' &&
                                    <MultipleBetsTicket key={data.id} ticket={data} infoTicket={props.infoTicket} obfuscateTicketId={props.obfuscateTicketId} isSnapshot={props.isSnapshot} />
                                }
                                {data.type === 'systembets' &&
                                    <SystemBetsTicket key={data.id} ticket={data} infoTicket={props.infoTicket} openCheckSystemBets={props.openCheckSystemBets} obfuscateTicketId={props.obfuscateTicketId} isSnapshot={props.isSnapshot} hideAmounts={props.hideAmounts} />
                                }
                            </div>
                            <Legend />
                            {props.infoTicket && !props.hideOperatorFunctions &&
        		        		<div className="checkbet-operator-functions">
                            		{conf.rs.pctk && window?.appConfig?.TERMINAL_AGENCY && 
                                		<div>
	                                        <div className="checkbet-button ml-auto mr-auto my-bets-printer" onClick={() => { window.printTerminalCopy(data.id)}}>
	                                            <i className="fas fa-print" />
	                                        </div>
	                                        <div className="checkbet-operator-functions-desc" >{getLabel('checkbet.print_copy')}</div>
                                        </div>
                            		}
                            		{data.reprintReceipt && window?.appConfig?.TERMINAL_AGENCY && 
                            			<div>
	                                        <div className="checkbet-button ml-auto mr-auto my-bets-printer" onClick={() => { window.reprintTerminalTicket(data.id); props.close()}}>
	                                            <i className="fas fa-print" />
	                                        </div>
	                                        <div className="checkbet-operator-functions-desc" >{getLabel('retail.operator_menu.form_button.reprint_receipt')}</div>
                                        </div>
                            		}
                                    <div id="retail-purchase-again">
                                        <div  className="checkbet-button ml-auto mr-auto my-bets-cart" onClick={() => { props.purchaseTicket(data.id, data.psv) } }>
                                            <i className="fas fa-solid fa-coins"></i>
                                        </div>
                                        <div className="checkbet-operator-functions-desc" >{getLabel('checkbet.purchase_again')}</div>
                                    </div>
                                    <div>
                                        <div className="checkbet-button ml-auto mr-auto my-bets-cart" onClick={() => { props.reloadTicketInCart(data.id, data.psv) } }>
                                            <i className="fas fa-cart-plus" />
                                        </div>
                                        <div className="checkbet-operator-functions-desc" >{getLabel('checkbet.reload_in_betslip')}</div>
                                    </div>
                                </div>
                            }
                        </>
                    }
                </div>
            }
        </div>
    );
}

export default CheckBetLayout3;